/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Languageathomeisgerman4Inputs */



/**

* @param {_Field_Languageathomeisgerman4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_languageathomeisgerman4 = /** @type {((inputs?: _Field_Languageathomeisgerman4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Languageathomeisgerman4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Zuhause wird Deutsch gesprochen")
});
export { _field_languageathomeisgerman4 as "_field_languageAtHomeIsGerman" }